import { render } from "./ResourcesMobileGroup1.vue?vue&type=template&id=f63b1cf8&scoped=true"
import script from "./ResourcesMobileGroup1.vue?vue&type=script&lang=js"
export * from "./ResourcesMobileGroup1.vue?vue&type=script&lang=js"

import "./ResourcesMobileGroup1.vue?vue&type=style&index=0&id=f63b1cf8&scoped=true&lang=css"

import exportComponent from "/home/runner/work/ic-lab/ic-lab/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f63b1cf8"]])

export default __exports__